// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterMenu } from '@/components/filter-menu';
import { TableControlContainer } from '@/components/table-control-container';
import { Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';
import type { DatePickerSlotProps } from '@mui/x-date-pickers-pro';
import { DateTime } from 'luxon';

interface Props {
  startDate: DateTime | null;
  endDate: DateTime | null;
  typeOptions: { id: string; label: string; isActive: boolean }[];
  sourceOptions: { id: string; label: string; isActive: boolean }[];
  actorOptions: { id: string; label: string; isActive: boolean }[];
  onStartDateChange: (date: DateTime | null) => void;
  onEndDateChange: (date: DateTime | null) => void;
  onTypeFilterChange: (value: string, active: boolean) => void;
  onSourceFilterChange: (value: string, active: boolean) => void;
  onActorFilterChange: (value: string, active: boolean) => void;
}

/**
 * Filter controls for the audit table including date range and object type filters.
 */
export function FullAuditTableFilterRow(props: Props) {
  const {
    startDate,
    endDate,
    typeOptions,
    sourceOptions,
    actorOptions,
    onStartDateChange,
    onEndDateChange,
    onTypeFilterChange,
    onSourceFilterChange,
    onActorFilterChange,
  } = props;
  const datePickerProps: DatePickerSlotProps<DateTime, false> = {
    field: { clearable: true },
    textField: {
      size: 'small' as const,
      sx: { maxWidth: '12em' },
    },
  };

  return (
    <TableControlContainer>
      <Stack
        useFlexGap
        spacing={1}
        flexWrap="wrap"
        direction="row"
        marginRight="auto"
      >
        <DatePicker
          label="Start date"
          value={startDate}
          format="yyyy-MM-dd"
          slotProps={datePickerProps}
          onChange={onStartDateChange}
        />
        <DatePicker
          label="End date"
          value={endDate}
          format="yyyy-MM-dd"
          slotProps={datePickerProps}
          onChange={onEndDateChange}
        />
        <FilterMenu
          label="Type"
          options={typeOptions}
          onChangeOption={(type, isActive) =>
            onTypeFilterChange(type, isActive)
          }
        />
        <FilterMenu
          label="Source"
          options={sourceOptions}
          onChangeOption={(source, isActive) =>
            onSourceFilterChange(source, isActive)
          }
        />
        <FilterMenu
          label="Actor"
          options={actorOptions}
          onChangeOption={(actor, isActive) =>
            onActorFilterChange(actor, isActive)
          }
        />
      </Stack>
    </TableControlContainer>
  );
}
